import type { Alert } from "@/services/api/guardiansv2/types";
import { timelineSubjectKey } from "../shared/subjectKey";

export interface AlertTimelineTarget {
  missionId?: string;
  taskId?: string;
  /** Key joining the alert's subject onto its timeline row. */
  subjectKey: string;
  /** Audit already linked to the alert, if any. */
  auditId: string | null;
}

/** Human label for the alert's subject, used in the cross-nav button. */
const ENTITY_LABELS: Record<string, string> = {
  trigger_event: "trigger event",
  trigger: "trigger event",
  step: "tool call",
  tool_call: "tool call",
  task: "task",
  mission: "mission",
  artifact: "artifact",
  interaction: "interaction",
};

export function alertEntityLabel(alert: Alert): string {
  return ENTITY_LABELS[alert.subject.type] ?? ENTITY_LABELS[alert.source] ?? "entity";
}

/**
 * Where an alert points in the Guardians timeline, or null when it has no
 * mission or task scope.
 */
export function alertTimelineTarget(alert: Alert): AlertTimelineTarget | null {
  const missionId = alert.scope.mission_id;
  const taskId = alert.scope.task_id;
  if (!missionId && !taskId) return null;

  const subjectKey = timelineSubjectKey({
    subject_type: alert.subject.type,
    subject_id: alert.subject.id,
    subject_version: alert.subject.version,
  });

  return {
    missionId: missionId ?? undefined,
    taskId: missionId ? undefined : taskId ?? undefined,
    subjectKey,
    auditId: alert.audit_id ?? null,
  };
}
